import React from 'react';

import './styles.css';

import logoImg from '../../assets/logo-gigage-white.png';

export default function Footer() {
  return (
    <footer>
      <a href="/">
        <img src={logoImg} alt="logo gigage" />
      </a>
    </footer>
  );
}
